import React from 'react';
import { Link } from 'react-router-dom';

export default function Sidebar({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.sidebar} onClick={(e) => e.stopPropagation()}>
        <h3 style={styles.title}>Menu</h3>
        <ul style={styles.list}>
          <li><Link to="/" style={styles.link}>🏠 Home</Link></li>
          <li><Link to="/add-playlist" style={styles.link}>➕ Add Playlist</Link></li>
  <li><a href="about.html" style={styles.link}>ℹ️ About</a></li>
          <li><Link to="contact.html" style={styles.link}>📞 Contact</Link></li>

        </ul>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed',
    top: 0, left: 0, bottom: 0, right: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    zIndex: 1000,
    display: 'flex',
    justifyContent: 'flex-start'
  },
  sidebar: {
    width: '260px',
    backgroundColor: 'var(--card-bg)',
    height: '100%',
    padding: '25px 20px',
    color: 'var(--accent-color)',
    boxShadow: '4px 0 10px rgba(0,0,0,0.2)',
    animation: 'slideIn 0.3s ease-out'
  },
  title: {
    marginBottom: '20px',
    fontSize: '1.5rem',
    fontWeight: 'bold'
  },
  list: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
  },
  link: {
    textDecoration: 'none',
    color: 'var(--accent-color)',
    fontSize: '1rem',
    display: 'block',
    padding: '10px 0',
    transition: 'all 0.2s ease-in-out',
  }
};
